// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"697":"9970a2df","787":"3ce4cc4d","824":"afafbdb6"}[chunkId] + ".chunk.js";
};